// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { ApiBase } from './apiBase';

export interface TeacherTemplate {
  content_type: string;
  query: string;
  preferences: Record<string, string>;
  content_preview: string;
  timestamp: number;
  template_state?: 'complete' | 'fallback';
  template_key?: string;
}

export interface TeacherTemplateListResponse {
  items: TeacherTemplate[];
  total: number;
}

export class ApiTeacherTemplates extends ApiBase {
  async listTemplates(limit = 20) {
    return this.client.get<TeacherTemplateListResponse>('/v1/memories/teacher-templates', {
      params: { limit },
    });
  }
}
